import { MouseEvent, ReactNode, useEffect, useState } from 'react'
import { clsx } from 'clsx'
import { AvatarStoryCircle } from './avatar-story-circle'
import { AvatarSize } from '../types'
import { AVATAR_SIZES, AVATAR_WITH_STORY_INNER_SIZES } from '../conf'
import { CallType } from '@weblite/ts-action/media-proxy'

export interface AvatarImageProps {
  children?: ReactNode
  src?: string
  alt?: string
  size?: AvatarSize
  className?: string
  onClick?: (e: MouseEvent<HTMLDivElement>) => unknown
  storyCount?: number
  seenStoryCount?: number
  storyLoading?: boolean
  joiningCall?: boolean
  ongoingCallType?: CallType
}

export function AvatarImage({
  children: childrenProp,
  src,
  alt = 'avatar-image',
  size = AvatarSize.SM,
  className,
  onClick,
  storyCount = 0,
  seenStoryCount = 0,
  storyLoading = false,
  ongoingCallType,
  joiningCall,
}: AvatarImageProps) {
  const innerSize =
    storyCount || ongoingCallType
      ? AVATAR_WITH_STORY_INNER_SIZES[size]
      : AVATAR_SIZES[size]

  return (
    <div
      className="avatar-base__root"
      style={{
        width: `${AVATAR_SIZES[size]}px`,
        height: `${AVATAR_SIZES[size]}px`,
      }}
      onClick={onClick}
    >
      <div
        className={clsx('avatar-base__inner', className)}
        style={{ width: `${innerSize}px`, height: `${innerSize}px` }}
      >
        {src ? (
          <img alt={alt} className="avatar-base__image" src={src} />
        ) : (
          childrenProp
        )}
      </div>
      {storyCount || ongoingCallType ? (
        <AvatarStoryCircle
          size={size}
          withExtraGap={false}
          storyCount={storyCount || 1}
          seenStoryCount={seenStoryCount || 0}
          uploading={(storyLoading && !ongoingCallType) || joiningCall}
          ongoingCallType={ongoingCallType}
        />
      ) : null}
    </div>
  )
}
